import React, { useState } from "react";
import { VuesaxBulkArrowRight2 } from "../components/ui/VuesaxBulkArrowRight2";

const faqData = [
  {
    question: "What is Baby Unicorn?",
    answer:
      "Baby Unicorn is a fun and family-friendly cryptocurrency designed to introduce kids and adults to the world of crypto through games, learning tools, and staking rewards — all in a magical, safe ecosystem.",
  },
  {
    question: "How do I buy Baby Unicorn tokens?",
    answer: "You can buy Baby Unicorn tokens through our presale portal or supported DEX once live.",
  },
  {
    question: "Is this token safe for kids?",
    answer: "Yes, Baby Unicorn is built with family-friendly principles and a safe ecosystem in mind.",
  },
  {
    question: "What can I do with BABYU tokens?",
    answer: "You can stake, trade, learn, and use them in our upcoming games and educational platforms.",
  },
  {
    question: "What is the vesting schedule?",
    answer: "The vesting schedule includes a fair distribution with timelines detailed on our tokenomics page.",
  },
];

export const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="flex flex-col lg:flex-row w-full max-w-[1344px] mx-auto items-start gap-8 px-6 md:px-10 lg:px-16 py-16 bg-[#2a2540] rounded-3xl mt-16 mb-16"  id="faq">
      
      {/* Left Side (Heading, Paragraph, then Image) */}
      <div className="flex flex-col gap-6 w-full lg:w-[50%]">
        {/* Header */}
        <header>
          <h1 className="font-fredoka text-4xl sm:text-5xl lg:text-6xl font-bold tracking-wider text-white leading-tight sm:leading-[56px] lg:leading-[72px]">
            <span>Baby Unicorn </span>
            <span className="bg-gradient-to-r from-pink-300 via-purple-300 to-blue-300 bg-clip-text text-transparent">
              Token Highlights
            </span>
          </h1>
        </header>

        {/* Paragraph */}
             <div className=" border-l [border-left-style:solid] border-transparent [border-image:linear-gradient(10deg,rgba(48,40,67,1)_16%,rgba(255,193,227,1)_25%,rgba(195,177,255,1)_41%,rgba(174,226,255,1)_58%,rgba(46,39,67,1)_78%)_1] flex relative items-center gap-2.5 pl-6 border-l border-transparent border-l-[4px] border-image-[linear-gradient(10deg,rgba(48,40,67,1)_16%,rgba(255,193,227,1)_25%,rgba(195,177,255,1)_41%,rgba(174,226,255,1)_58%,rgba(46,39,67,1)_78%)] border-image-slice-[1]">
          <p className="text-neutral-100 text-base sm:text-lg md:text-xl lg:text-[22px] leading-7 sm:leading-8">
            Find quick answers to the most common questions about Baby Unicorn —
            from how to get started, to how the token works, and everything in
            between.
          </p>
        </div>

        {/* Image below text */}
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/51b4ee4461a0b960fbb2616dbfe9ad39e54d27f7?placeholderIfAbsent=true&apiKey=0c11d46dd7d64d7a84bf3e17dbee5689" // Replace with real image
          alt="Baby Unicorn"
          className="w-full h-auto max-h-[300px] object-contain rounded-xl mt-4"
        />
      </div>

      {/* Right Side (FAQs) */}
      <div className="flex flex-col gap-6 w-full lg:w-[50%]">
        {faqData.map((faq, i) => (
          <div
            key={i}
            className="bg-[#3a3350] rounded-lg p-6 cursor-pointer transition-all duration-300 ease-in-out"
            onClick={() => toggleFAQ(i)}
          >
            <div className="flex items-center justify-between">
              <h3 className="font-[Baloo_2] font-semibold text-white text-xl sm:text-2xl">
                {faq.question}
              </h3>
              <div className={`transform transition-transform ${activeIndex === i ? "rotate-90" : "rotate-0"}`}>
                <VuesaxBulkArrowRight2 className="!w-6 !h-6" />
              </div>
            </div>
            {activeIndex === i && (
              <p className="mt-4 text-neutral-100 text-base sm:text-lg lg:text-[22px] leading-7 lg:leading-8">
                {faq.answer}
              </p>
            )}
          </div>
        ))}

        {/* CTA Button */}
        <div className="mt-4">
          <button className="px-6 py-3 rounded-lg bg-gradient-to-r from-pink-400 via-purple-400 to-blue-400 text-white font-bold text-lg shadow-md hover:shadow-xl transition-all">
            Learn More About BabyU
          </button>
        </div>
      </div>
    </div>
  );
};
